import React, { useEffect, useState } from "react";
import StudentHeader from "../components/StudentHeader";
import Footer from "../components/Footer";
import { useParams } from "react-router-dom";
import { Container, Card, Form, Row, Col, Button, Tab, Tabs, Image } from "react-bootstrap";
import Studentfirst from "../components/common-components/studentInfo/studentfirst";
import StudenInfoThird from "../components/common-components/studentInfo/StudentThird";
import StudentSecond from "../components/common-components/studentInfo/StudentSecon";
import ChangePassword from "../components/ChangePassword/ChangePassword";
const StudentProfile = (props) => {
const params = useParams()
    const [active, setActive] = useState(params.tab?params.tab:"home")

    useEffect(() => {
        setActive(params.tab)
    }, [params])

    return (
        <div className="dashbrd_pg muiheight">
            {console.log(active,'<---- active')}
            <StudentHeader />
            <div className="schl_prfl_pg">
                <Container className="custm_container">
                    <div className="prfl_wrap">
                        <div className="pg_hdng mb-4">
                            <h2>Student Profile</h2>
                        </div>

                        <div className="stdnt_prfl">
                            <Row>
                                {/* <Col md={4}>
                                    <Card className="pg_card">
                                        <Card.Body>
                                            <div className="stdnt_img">
                                                <Image src={clnt3} fluid />
                                            </div>
                                            <div className="stdnt_prfl_cntnt text-center">
                                                <h5 className="text_theme mt-3">
                                                    Kate M. Thompson
                                                </h5>
                                                <Image
                                                    src={sign}
                                                    fluid
                                                    className="sign_img"
                                                />
                                            </div>
                                        </Card.Body>
                                    </Card>
                                </Col> */}
                                <Col md={12}>
                                    <Card className="pg_card">
                                        <Card.Body>
                                            <div className="prfl_tabs">
                                                <Tabs
                                                    activeKey={active}
                                                    defaultActiveKey={active}
                                                    id="uncontrolled-tab-example"
                                                    className="mb-3"
                                                    onSelect={(e) => {
                                                        setActive(e)
                                                    }}
                                                >
                                                    <Tab
                                                        eventKey="home"
                                                        title="Basic Info"
                                                    >
                                                        <Studentfirst type={"Edit"} Button="Save" />
                                                    </Tab>
                                                    <Tab
                                                        eventKey="profile"
                                                        title="Other Info"
                                                    >
                                                        <StudentSecond />
                                                    </Tab>
                                                    <Tab
                                                        eventKey="contact"
                                                        title="Additional Info"
                                                    >
                                                        <StudenInfoThird Button="Save" />
                                                    </Tab>
                                                    <Tab
                                                        eventKey="pwsd"
                                                        title="Change Password"
                                                    >
                                                        <ChangePassword />
                                                    </Tab>
                                                </Tabs>
                                            </div>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            </Row>
                        </div>
                    </div>
                </Container>
            </div>
            <Footer />
        </div>
    );
};

export default StudentProfile;
